import 'react-app-polyfill/ie11';
import 'core-js/es/set';
import 'core-js/es/map';
import 'react-app-polyfill/ie9';


import React from 'react';
import ReactDOM from 'react-dom';
import { createStore, compose, applyMiddleware} from "redux";
import createSagaMiddleware from "redux-saga";
import { routerMiddleware } from "react-router-redux";
import history from "./history";
import { depositReducer } from './reducers'
import depositSagas from './sagas';

import './index.css';

import App from './App';
import './i18n';

import * as serviceWorker from './serviceWorker';

const sagaMiddleware = createSagaMiddleware();

const composeEnhancers =
    typeof window === "object" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({}) : compose;

const enhancer = composeEnhancers(applyMiddleware(sagaMiddleware, routerMiddleware(history)));

const store = createStore(depositReducer, enhancer);

sagaMiddleware.run(depositSagas);

ReactDOM.render(<App store={store} />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
